import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, put } from "../../../services/apiService";
import { showSnackbar } from "../../snackbar/Snackbar.slice";

const GET_EXCHANGES = "globalExchanges/get";
const MODIFY_EXCHANGE = "globalExchanges/modify";

export const getGlobalExchanges = createAsyncThunk(
  GET_EXCHANGES,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { token, acquirerID, acquirerName, status, code, category,  page = 1, pageSize = 5 } = payload;
      const endpoint = `/global-exchanges`;
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        acquirerName: acquirerName,
        acquirerID: acquirerID,
      };
      const params = {
        status: status,
        code: code,
        category: category,
        page: page,
        page_size: pageSize
      };

      const urlSearchParams = new URLSearchParams();
      for (const key in params) {
        const value = params[key];
        if (value !== null && value !== undefined && value !== "") {
          urlSearchParams.set(key, value.toString());
        }
      }
      const queryString = urlSearchParams.toString();
      const fullEndpoint = queryString ? `${endpoint}?${queryString}` : endpoint;

      const response = await get(fullEndpoint, { headers });
      return {
        exchanges: response.exchanges || [],
        page: response.page || page,
        pageSize: response.page_size || pageSize,
        totalRecords: response.total_records || (response.exchanges ? response.exchanges.length : 0),
      };
    } catch (error) {
      console.error("Error getting exchanges thunk:", error);
      dispatch(
        showSnackbar({ message: "Error getting exchanges data", severity: "error" })
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateGlobalExchange = createAsyncThunk(
  MODIFY_EXCHANGE,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const {
        token,
        exchangeCode,
        exchangeCatalogId,
        exchangeRowKey,
        exchangeStatus,
        position,
        currencies,
        kycIdentityEnabled,
        kycProviderCode,
        kycProviderAccountKey,
        kycIdentityThresholdUsd,
        amlEnabled,
        acquirerId,
        acquirerName,
        onSuccess = false,
      } = payload;
      const endpoint = `/global-exchanges/${exchangeCode}`;
      const catalogIdNum = Number(exchangeCatalogId);
      const hasCatalogId = exchangeCatalogId != null && exchangeCatalogId !== "" && Number.isFinite(catalogIdNum);
      const data = {
        version: "04.09.01",
        status: exchangeStatus,
        position: position,
        currencies: currencies,
        kyc_identity_enabled: kycIdentityEnabled,
        kyc_provider_code: kycProviderCode,
        kyc_provider_account_key: kycProviderAccountKey,
        kyc_identity_threshold_usd: kycIdentityThresholdUsd,
        aml: amlEnabled,
        ...(hasCatalogId ? { id: catalogIdNum } : {}),
      };
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        acquirerName: acquirerName,
        acquirerID: acquirerId,
      };

      await put(endpoint, data, { headers });
      dispatch(
        showSnackbar({ message: `Exchange updated successfully`, severity: "success" })
      );
      if (onSuccess) onSuccess();
      return { exchangeCode, exchangeRowKey: exchangeRowKey || exchangeCode, exchangeStatus, position, currencies };
    } catch (error) {
      console.error("Error modifying exchange thunk:", error);
      dispatch(showSnackbar({ message: "Exchange modification failed", severity: "error" }));
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);